<template>
  <div class="row">
    <div v-if="index > 0" class="col-12">
      <hr class="my-2" />
    </div>
    <div class="col-12 col-sm-9">
      <div class="item-name">
        <span class="title">{{ title }}</span>
        <span class="subtitle">({{ subtitle }})</span>
      </div>
      <div class="user-name">
        <span>{{ item.user.name }}</span>
        <span v-if="item.user.hvac_id"
          >&nbsp;(ID: {{ item.user.hvac_id }})</span
        >
      </div>

      <div v-if="isEvent && item.includedCourses.length" class="mt-4">
        <h5 class="font-weight-bold" >Included Courses</h5>
        <ul v-for="course in item.includedCourses" class="mt-1 mb-0">
          <li style="font-size: 12px;">
            <a :href="route('catalog.course', {course: course.id})">{{ course.name }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-12 col-sm-3 text-right">
      <a
        v-if="isCourse && !!item.launch_url"
        :href="item.launch_url"
        target="_blank"
        class="btn-sm btn-primary"
        >Begin Training</a
      >
      <a
        v-else-if="isEvent && !!item.ical_url"
        :href="item.ical_url"
        target="_blank"
        class="btn-sm btn-primary"
        >Add to Calendar</a
      >
      <a
        v-else-if="isLearningPath && !!item.details_url"
        :href="item.details_url"
        class="btn-sm btn-primary"
        >Begin Training</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    isCourse() {
      return !!this.item.item_type && this.item.item_type === "course";
    },
    isEvent() {
      return !!this.item.item_type && this.item.item_type === "event";
    },
    isLearningPath() {
      return !!this.item.item_type && this.item.item_type === "learning_path";
    },
    subtitle() {
      if (this.isLearningPath) {
        return "Learning Path";
      } else if (this.isEvent) {
        return `${this.item.enrollable.type_label} Event`;
      } else {
        return "Online Course";
      }
    },
    title() {
      if (this.isLearningPath) {
        return this.item.learning_path.name;
      } else if (this.isEvent) {
        return `${this.item.enrollable.name} - ${this.$moment(
          this.item.enrollable.start_date
        ).format("MM/DD/YY")}`;
      } else {
        return this.item.enrollable.name;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-name {
  font-size: 14px;
  .title {
    font-weight: bold;
  }
  .subtitle {
    color: #888888;
  }
}
.user-name {
  font-size: 14px;
}
.discount {
  color: #888888;
  text-decoration: line-through;
}
</style>